import { ok, err, Result } from 'neverthrow'
import { RpcResponse, RpcRequest } from '../interfaces'

export function validateJsonRpcResponse<T=unknown>(
  response: unknown,
  request: RpcRequest<unknown>,
): Result<RpcResponse<T>, string> {
  const r = response as RpcResponse<T>

  if (r.jsonrpc !== '2.0') {
    return err('response does not have a jsonrpc property of "2.0"')
  }

  if (r.id !== request.id) {
    return err('response and request id must match')
  }

  if (r.error) {
    if (!r.error.code) {
      return err('an error response must contain a code property')
    }
  } else if (!r.result) {
    return err('the response must either contain a result property or an error property')
  }

  return ok(response as RpcResponse<T>)
}
